import { render } from "./TotalShoppingForYearReportGrapics.vue?vue&type=template&id=0b8857fc"
import script from "./TotalShoppingForYearReportGrapics.vue?vue&type=script&lang=js"
export * from "./TotalShoppingForYearReportGrapics.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__